import * as React from 'react';
import * as styles from './SummaryDesktop.css';
import { VisibleViolationsWarningContainer } from '../../../VisibleViolationsWarning';
import { ServicePickerWidgetContainer } from '../../../microfrontends/ServicePickerWidget';
import { ActionButtonsContainer } from '../../../ActionButtons';
import { SubagentNotEnoughMoneyModalContainer } from '../../../SubagentNotEnoughMoneyModal';

export const SummaryDesktop = () => {
  return (
    <div className={styles['summary']}>
      <ServicePickerWidgetContainer />

      <div className={styles['checkout']}>
        <SubagentNotEnoughMoneyModalContainer />
        <VisibleViolationsWarningContainer />
        <div className={styles['actions']}>
          <div className={styles['actions-buttons']}>
            <ActionButtonsContainer />
          </div>
        </div>
      </div>
    </div>
  );
};
